export default __webpack_public_path__ + "static/media/creativity.b29e5b01.svg";